import { Navigate, Route, Routes } from "react-router-dom";

import { EditSpacePage } from "../features/spaces/pages/edit-space-page/EditSpacePage";
import { NotFoundPage } from "./system/NotFoundPage";
import { PermissionPage } from "../features/spaces/pages/permissions-page/PermissionsPage";

/**
 * Space settings routes (rail "Settings"). The screens draw their own layout (Ark-Settings board: one page with
 * sections); the old "Edit Overview / Permissions" side bar is gone.
 */
export function EditSpaceModule() {
  return (
    <Routes>
      <Route index element={<Navigate to="space" replace />} />
      <Route path="space" element={<EditSpacePage />} />
      <Route path="permission" element={<PermissionPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
